import { render, staticRenderFns } from "./StoreUnitCard.vue?vue&type=template&id=23cba626&scoped=true&"
import script from "./StoreUnitCard.vue?vue&type=script&lang=js&"
export * from "./StoreUnitCard.vue?vue&type=script&lang=js&"
import style0 from "./StoreUnitCard.vue?vue&type=style&index=0&id=23cba626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cba626",
  null
  
)

export default component.exports